import { WsEventListener } from "@fidget/common/services/eventsListener";
import { ITagGroupsStore } from "./TagGroupStore";

export class TagGroupsStoreEventListener implements WsEventListener {
  constructor(private _tagGroupsStoreFinder: () => ITagGroupsStore, public name: string) {}

  get tagGroupsStore(): ITagGroupsStore {
    return this._tagGroupsStoreFinder();
  }

  connected() {
    this.tagGroupsStore.loadTagGroups();
  }
}
